module.exports = __webpack_public_path__ + "static/media/logo.cc567fa9.png";